<!-- RegistrierenSeite.vue -->
<template>
  <div class="login-page">
    <h1>Registrieren</h1>
    <div v-if="!registrationSuccess" >
      <h3>Bitte gib deine E-Mail-Adresse ein</h3>
      <form @submit.prevent="register" class="login-form">
        <input
        class="textInput"
          v-model="email"
          type="email"
          placeholder="E-Mail"
          :class="{ 'error': errors.email }"
          required
        />
        <p v-if="errors.email" class="error-text">{{ errors.email }}</p>
        <p v-if="errors.general" class="error-text">{{ errors.general }}</p>
        
        <div class="register-link">
          <h4>
            Du hast schon ein Schlüsselloch?
            <router-link to="/login">
              Jetzt Einloggen</router-link>
          </h4>
        </div>

        <div class="register-link">
          <h4>
            <input type="checkbox" v-model="dsgvoAccepted" />
            Ich habe die <router-link to="/datenschutz">Datenschutzerklärung</router-link> gelesen und stimme der Verarbeitung meiner E-Mail-Adresse zu.
          </h4>
        </div>
        <p v-if="errors.dsgvo" class="error-text">{{ errors.dsgvo }}</p>

        <button
          type="submit"
          :disabled="isLoading"
          :class="{ 'loading': isLoading }"
        >
          {{ isLoading ? 'Registriere...' : 'Account erstellen' }}
        </button>
      </form>
    </div>

    <transition name="fade">
      <RegistrierenSchluesseloch
        v-if="registrationSuccess"
        :email="email"
        :registrationToken="registrationToken"
        @error="handleSchluesselochError"
        @success="handleSchluesselochSuccess"
      />
    </transition>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import RegistrierenSchluesseloch from '@/components/RegistrierenSchluesseloch.vue'

export default {
  name: 'RegistrierenSeite',
  
  components: {
    RegistrierenSchluesseloch
  },
  
  setup() {
    const router = useRouter()
    const email = ref('')
    const errors = ref({})
    const isLoading = ref(false)
    const dsgvoAccepted = ref(false)
    const registrationSuccess = ref(false)
    const registrationToken = ref('')

    const validate = () => {
      errors.value = {}
      if (!email.value.trim()) {
        errors.value.email = 'Bitte gib eine E-Mail-Adresse ein'
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
        errors.value.email = 'Bitte gib eine gültige E-Mail-Adresse ein'
      }
      if (!dsgvoAccepted.value) {
        errors.value.dsgvo = 'Bitte stimme der Datenschutzerklärung zu'
      }
      return Object.keys(errors.value).length === 0
    }

    const handleSchluesselochError = (error) => {
      errors.value.general = error
      registrationSuccess.value = false
    }

    const handleSchluesselochSuccess = () => {
      // Redirect to login page after successful keyhole generation and download
      setTimeout(() => {
        router.push('/AccountPage')
      }, 1500)
    }

    const register = async () => {
      if (!validate()) return

      try {
        isLoading.value = true
        errors.value = {} // Clear previous errors
        
        console.log('Starting registration for email:', email.value)

        // Step 1: Register the user
        const registerResponse = await fetch('https://laubloch.de/backend/account.php?action=register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: email.value
          })
        })

        const registerData = await registerResponse.json()
        console.log('Registration response:', registerData)
        
        if (!registerResponse.ok || !registerData.success) {
          throw new Error(registerData.error || 'Registrierung fehlgeschlagen')
        }

        // Step 2: Send registration email
        console.log('Sending registration email...')
        const emailResponse = await fetch('https://laubloch.de/backend/registration_mail.php', {  
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: email.value,
            token: registerData.token
          })
        })

        const emailData = await emailResponse.json()
        console.log('Email response:', emailData)
        
        if (!emailResponse.ok || !emailData.success) {
          throw new Error(emailData.error || 'E-Mail konnte nicht gesendet werden')
        }

        // Only set success if both operations completed
        registrationToken.value = registerData.token
        registrationSuccess.value = true
        console.log('Registration process completed successfully')

      } catch (error) {
        console.error('Registration error:', error)
        errors.value.general = error.message
        registrationSuccess.value = false
      } finally {
        isLoading.value = false
      }
    }

    return {
      email,
      errors,
      isLoading,
      dsgvoAccepted,
      registrationSuccess,
      registrationToken,
      register,
      handleSchluesselochError,
      handleSchluesselochSuccess
    }
  }
}
</script>

<style scoped>
.register-link a:visited {
  color: black;
}
</style>
